import {
    YouZanDetail,
    YouZanEdit,
    YouZanCategoryProps,
    yzBatchUpdateCategory
} from '@/api/prod/center'
import store from '@/store'

// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
    return imgsArr.filter(img => {
        if (!img) {
            return false
        } else if (typeof img === 'object') {
            return false
        } else {
            return true
        }
    })
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (r.skuList && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            return isRequest ? {
                ...item,
                skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
                ...item,
                skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }

    if (isRequest) {
        if (r.deliverMethods) {
            ['express' , 'cityDelivery', 'selfPick'].forEach(key => {
                r[key] = r.deliverMethods.includes(key)
            })
        }
        if (!r.preSaleType) {
            r.presaleParam = {
                pre_sale_type: -1
            }
        }
        if (r.presaleParam.etd_start) {
            r.presaleParam.etd_start = new Date(r.presaleParam.etd_start).valueOf()
        }
        if (r.pre_sale_range[0]) {
            r.presaleParam.pre_sale_start = new Date(r.pre_sale_range[0]).valueOf()
        }
        if (r.pre_sale_range[1]) {
            r.presaleParam.presale_end = new Date(r.pre_sale_range[1]).valueOf()
        }

        if (r.balance_due_range[0]) {
            r.presaleParam.balance_due_start = new Date(r.balance_due_range[0]).valueOf()
        }
        if (r.balance_due_range[1]) {
            r.presaleParam.balance_due_end = new Date(r.balance_due_range[1]).valueOf()
        }


        let attributes = {
            category_names: r.category_names,
            leaf_category_id: r.categoryId,
            publics: r.attributes,
            status: 1
        }
        r.attributes = JSON.stringify(attributes)
        r.postage = r.postage ? r.postage : 0

    } else {
        let {express , cityDelivery, selfPick, presaleParam, attributes, display} = r;
        let deliverMethods = [];
        express && deliverMethods.push('express');
        cityDelivery && deliverMethods.push('cityDelivery');
        selfPick && deliverMethods.push('selfPick');
        r.deliverMethods = deliverMethods;

        presaleParam = presaleParam ? JSON.parse(presaleParam) : {
            pre_sale_type: -1
        }
        
        r.preSaleType = presaleParam.pre_sale_type !== -1
        if (presaleParam.etd_start) {
            presaleParam.etd_start = new Date(presaleParam.etd_start)
        }

        let pre_sale_range = [];
        if (presaleParam.pre_sale_start) {
            pre_sale_range[0] = new Date(presaleParam.pre_sale_start)
        }
        if (presaleParam.presale_end) {
            pre_sale_range[1] = new Date(presaleParam.presale_end)
        }
        r.pre_sale_range = pre_sale_range

        let balance_due_range = [];
        if (presaleParam.balance_due_start) {
            balance_due_range[0] = new Date(presaleParam.balance_due_start)
        }
        if (presaleParam.balance_due_end) {
            balance_due_range[1] = new Date(presaleParam.balance_due_end)
        }
        r.balance_due_range = balance_due_range

        r.presaleParam = presaleParam
        attributes = attributes ? JSON.parse(attributes) : {}
        attributes = attributes.publics || []
        r.attributes = attributes
        
        if (!display && display !== 0) {
            r.display = 1
        }
    }
    

    return isRequest ? {
        ...r,
        autoListingTime: r.autoListingTime ? new Date(r.autoListingTime).valueOf() : null,
        images: JSON.stringify(r.images ? _filterInvalidImg(r.images) : []),
        specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
        presaleParam: JSON.stringify(r.presaleParam),
    } : {
        ...r,
        autoListingTime: r.autoListingTime ? new Date(r.autoListingTime) : null,
        images: r.images ? JSON.parse(r.images) : [],
        specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : []
    }
}

// 编辑详情
export function editYzDetail(data) {
    return YouZanEdit(_formatGoodsItem(data, true)).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

// 获取详情资料
export function getYzDetail(baseItemId) {
    return YouZanDetail({
        baseItemId
    }).then(res => {
        if (res.result === 1) {
            // debugger;
            return _formatGoodsItem(res.data)
        } else {
            return false
        }
    })
}

// 查询类目属性
export function getCategoryProps(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('yz') || 151987
    let _data = {
        ...data,
        shopId: data.shopId ? data.shopId : _shopId // 默认店铺
    }
    return YouZanCategoryProps(_data).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
            return false
        }
    })
}

// 批量修改类目
export function batchYzCategory(data) {
    return yzBatchUpdateCategory(data).then(res => {
        if (res.result === 1) {
        return true
        } else {
        return false
        }
    })
}
